import { Icon } from "components";
import { ARROW_LEFT_RIGHT } from "icons";
import { SidebarMenuItem, SidebarMenuButton } from "ui/components/sidebar";

export function SwitchApp() {
  return (
    <SidebarMenuButton asChild className="mb-4">
      <a target="__blank" href="https://everest.7span.work">
        <Icon icon={ARROW_LEFT_RIGHT} />
        <span>Switch to Everest</span>
      </a>
    </SidebarMenuButton>
  );
}
